module.exports = __webpack_public_path__ + "static/media/24.3f655d60.jpg";